import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { LifeEvent } from '../LifeEvent.ts';
import { LifeEventsApi } from '../../../apis/LifeEventsApi/LifeEventsApi.ts';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';

export function useGetLifeEventById() {
    const id = useIdFromRoute();
    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.lifeEvent, id],
        queryFn: async () => {
            const result = await LifeEventsApi.getLifeEventById(id!);
            return result ? new LifeEvent(result) : result;
        },
        enabled: !!id,
    });
}
